// // src/pages/MCLPage.js
// import React, { useContext, useState } from 'react';
// import {
//   Box,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Slider,
//   Button,
//   Snackbar,
//   Typography
// } from '@mui/material';
// import { SettingsContext } from '../context/SettingsContext';

// export default function MCLPage() {
//   const { mclSettings, setMclSettings, setHasSavedMCL } = useContext(SettingsContext);
//   const [ear, setEar] = useState(mclSettings?.ear || 'Left');
//   const [mcl, setMcl] = useState(mclSettings?.mcl || 50);
//   const [openSnackbar, setOpenSnackbar] = useState(false);

//   const handlePlayStory = () => {
//     try {
//       // adjust the path/name to your actual story file in src/assets
//       const audio = new Audio(require(`../assets/four.wav`));
//       // map MCL (0-100) to volume 0.0–1.0
//       audio.volume = mcl / 100;
//       audio.play();
//     } catch (err) {
//       console.error('Error playing story:', err);
//     }
//   };

//   const handleSave = () => {
//     setMclSettings({ ear, mcl });
//     setHasSavedMCL(true);
//     setOpenSnackbar(true);
//   };

//   return (
//     <Box maxWidth={400} mx="auto" py={3}>
//       <Typography variant="h6" align="center" gutterBottom>
//         Most Comfortable Level
//       </Typography>

//       <FormControl fullWidth sx={{ mb: 3 }}>
//         <InputLabel>Ear</InputLabel>
//         <Select value={ear} label="Ear" onChange={e => setEar(e.target.value)}>
//           <MenuItem value="Left">Left</MenuItem>
//           <MenuItem value="Right">Right</MenuItem>
//         </Select>
//       </FormControl>

//       <Box sx={{ mb: 3 }}>
//         <Box display="flex" justifyContent="space-between" alignItems="center">
//           <InputLabel>MCL (dB)</InputLabel>
//           <Typography>{mcl} dB</Typography>
//         </Box>
//         <Slider
//           value={mcl}
//           min={0}
//           max={100}
//           onChange={(e, v) => setMcl(v)}
//           valueLabelDisplay="off"
//         />
//       </Box>

//       <Button
//         variant="outlined"
//         fullWidth
//         sx={{ mb: 2 }}
//         onClick={handlePlayStory}
//       >
//         Play 
//       </Button>

//       <Button variant="contained" fullWidth onClick={handleSave}>
//         SAVE
//       </Button>

//       <Snackbar
//         open={openSnackbar}
//         autoHideDuration={3000}
//         message={`MCL saved at ${mcl} dB`}
//         onClose={() => setOpenSnackbar(false)}
//       />
//     </Box>
//   );
// }


// src/pages/MCLPage.js
import React, { useContext, useState } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Slider,
  Button,
  Snackbar,
  Typography
} from '@mui/material';
import { SettingsContext } from '../context/SettingsContext';
import './LoudnessPage.css'; // reuse the same CSS

export default function MCLPage() {
  const { mclSettings, setMclSettings, setHasSavedMCL } = useContext(SettingsContext);
  const [ear, setEar] = useState(mclSettings?.ear || 'Left');
  const [mcl, setMcl] = useState(mclSettings?.mcl || 50);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handlePlayStory = () => {
    try {
      const audio = new Audio(require(`../assets/four.wav`));
      audio.volume = mcl / 100;
      audio.play();
    } catch (err) {
      console.error('Error playing story:', err);
    }
  };

  const handleSave = () => {
    setMclSettings({ ear, mcl });
    setHasSavedMCL(true);
    setOpenSnackbar(true);
  };

  return (
    <Box className="loudness-page">
      <Typography className="page-title" variant="h6">
        Most Comfortable Level
      </Typography>

      <FormControl fullWidth className="form-row">
        <InputLabel>Ear</InputLabel>
        <Select
          value={ear}
          label="Ear"
          onChange={e => setEar(e.target.value)}
        >
          <MenuItem value="Left">Left</MenuItem>
          <MenuItem value="Right">Right</MenuItem>
        </Select>
      </FormControl>

      <Box className="form-row">
        <Box className="slider-label">
          <InputLabel>MCL (dB)</InputLabel>
          <Typography>{mcl} dB</Typography>
        </Box>
        <Slider
          value={mcl}
          min={0}
          max={100}
          onChange={(e, v) => setMcl(v)}
          valueLabelDisplay="off"
        />
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 3 }}>
        <Button
          variant="outlined"
          fullWidth
          className="btn-outline"
          onClick={handlePlayStory}
        >
          Play Story
        </Button>
        <Button
          variant="contained"
          fullWidth
          className="btn-primary"
          onClick={handleSave}
        >
          SAVE
        </Button>
      </Box>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        message={`MCL saved at ${mcl} dB`}
        onClose={() => setOpenSnackbar(false)}
      />
    </Box>
  );
}
